import * as React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { PlayerCapabilities } from 'ATVWebPlayer'
import {
  playerConfigDataSelector,
  whisperCacheDataSelector,
  autoplaySelector,
} from '../../selectors/player'
import { IDetailPageState } from '../../reducers'
import {
  PlayerIntegration,
  PlayerContentConfig,
  PlaybackContentLink,
} from '../../integrations/playerIntegration'
import {
  playerClosedOrTitleChanged,
  setPlayerCapabilities,
  startPlayback,
} from '../../actions/player'
import { DetailPageActions, DetailPageActionTypes } from '../../actions'
import { PLAYER_ELEMENT_ID } from '../../integrations/player/config'
import { createBanner } from '../../actions/banner'
import { StringId } from '../localizer/stringId'
import { MessageTypes } from '@dvui'
import './player.module.scss'

export type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

type Overflow = 'hidden' | 'visible'

const setBodyOverflow = (overflow: Overflow) => {
  document.getElementsByTagName('body')[0].style.overflow = overflow
}

const setPlayerClass = (className: string) => {
  document.getElementById(PLAYER_ELEMENT_ID)!.className = className
}

const onPlay = (_content: PlayerContentConfig) => {
  setPlayerClass('dv-player-fullscreen')
  setBodyOverflow('hidden')
}

const onClosed = (content: PlayerContentConfig) => {
  setPlayerClass('')
  setBodyOverflow('visible')
  playerClosedOrTitleChanged(content, true)
}

const onAsinChanged = (content: PlayerContentConfig) => {
  playerClosedOrTitleChanged(content, false)
}

const onAborted = () => {
  //surface a modal here
  console.log('aborted')
}

export const PlayerConnected = ({
  setPlayerCapabilities,
  startPlayback,
  createError,
  ...props
}: Props) => {
  const onPlayerCapabilities = (capabilities: PlayerCapabilities) => {
    setPlayerCapabilities(capabilities)
    const { autoplay } = props
    if (autoplay) {
      setTimeout(() => {
        startPlayback(autoplay)
      })
    }
  }

  const liveIncompatibleCallback = () =>
    createError(StringId.DV_WEB_LIVE_NOT_SUPPORTED_BODY)

  const integrationProps = {
    ...props,
    onAsinChanged,
    onPlay,
    onClosed,
    onAborted,
    liveIncompatibleCallback,
    onPlayerCapabilities,
  }
  return <PlayerIntegration {...integrationProps} />
}
const mapStateToProps = (state: IDetailPageState) => ({
  playerConfig: playerConfigDataSelector(state),
  whisperCacheData: whisperCacheDataSelector(state),
  userAgent: state.requestContext!.userAgent,
  playbackLinkData: state.player.playbackLinkData || undefined,
  autoplay: autoplaySelector(state),
})

const mapDispatchToProps = (dispatch: Dispatch<DetailPageActions>) => ({
  setPlayerCapabilities: (capabilities: PlayerCapabilities) =>
    dispatch(setPlayerCapabilities(capabilities)),
  onPlayFailure: () => {
    dispatch({ type: DetailPageActionTypes.PlaybackFailed })
  },
  startPlayback: (playbackLinkData: PlaybackContentLink) =>
    dispatch(startPlayback(playbackLinkData)),
  createError: (stringId: StringId) =>
    dispatch(createBanner(MessageTypes.error, stringId)),
})

export const Player = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerConnected)
